import React, { useState, useEffect } from "react";

const TypeWritter = ({text}) => {
  const [currentText, setCurrentText] = useState("");

  const typeWriter = (text, i, cb) => {
    if (i < text.length + 1) {
      setCurrentText(text.substring(0, i++));
      const rndTyping = 250 - Math.random() * 100;
      setTimeout(() => {
        typeWriter(text, i++, cb);
      }, rndTyping);
    } else if (i === text.length + 1) {
      setTimeout(() => {
        delWriter(text, i, cb);
      }, 1000);
    }
  };

  const delWriter = (text, i, cb) => {
    if (i >= 0) {
      setCurrentText(text.substring(0, i--));
      const rndBack = 10 + Math.random() * 100;
      setTimeout(() => {
        delWriter(text, i, cb);
      }, rndBack);
    } else if (typeof cb === "function") {
      setTimeout(cb, 1000);
    }
  };

  const startWriter = (i) => {
    if (typeof text[i] === "undefined") {
      setTimeout(() => {
        startWriter(0);
      }, 1000);
    } else if (i < text[i].length + 1) {
      typeWriter(text[i], 0, () => {
        startWriter(i + 1);
      });
    }
  };

  useEffect(() => {
    setTimeout(() => {
      startWriter(0);
    }, 1000);
  }, []);

  return currentText;
};

export default TypeWritter;
